import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createColumnHelper } from "@tanstack/react-table";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import {
  emptyString,
  tableColumns,
  CONSUMER_RESPONSES_LABELS,
} from "../../constants";
import {
  UTCToDateFormat,
  UTCToDateTimeFormatWithoutSeconds,
} from "../../../../shared";

const {
  ORDER_NUMBER,
  ORDER_DATE,
  SURVEY_COMPLETION_DATE,
  SENTIMENT_RATING,
  TRANSACTION_RATING,
  INTERNAL_NOTES,
} = CONSUMER_RESPONSES_LABELS;

const columnHelper = createColumnHelper();
export const consumerResponseColumns = (
  isBrandInboxActive,
  getInternalNotesModal,
  customerId,
  customerName
) => {
  return [
    columnHelper.accessor("externalOrderId", {
      header: () => ORDER_NUMBER,
      size: tableColumns.SIZE_120,
    }),
    columnHelper.accessor("orderDate", {
      header: () => ORDER_DATE,
      size: tableColumns.SIZE_120,
      cell: ({ row }) => {
        const userResponseData = row.original;
        return userResponseData.orderDate
          ? UTCToDateFormat(userResponseData.orderDate)
          : emptyString;
      },
    }),
    columnHelper.accessor("surveyCompletionDate", {
      header: () => SURVEY_COMPLETION_DATE,
      minSize: tableColumns.SIZE_180,
      cell: ({ row }) => {
        const userResponseData = row.original;
        return userResponseData.surveyCompletionDate
          ? UTCToDateTimeFormatWithoutSeconds(
              userResponseData.surveyCompletionDate
            )
          : emptyString;
      },
    }),
    columnHelper.accessor("guestSentiments", {
      header: () => SENTIMENT_RATING,
      cell: ({ row }) => (
        <div className="text-center">{row.original.guestSentiments}</div>
      ),
    }),
    columnHelper.accessor("averageGuestTransaction", {
      header: () => TRANSACTION_RATING,
      cell: ({ row }) => (
        <div className="text-center">
          {row.original.averageGuestTransaction}
        </div>
      ),
    }),
    ...(isBrandInboxActive
      ? [
          columnHelper.accessor("action", {
            header: () => <div className="text-center">{INTERNAL_NOTES}</div>,
            enableSorting: false,
            cell: ({
              row: {
                original: { orderId },
              },
            }) => {
              return (
                <div className="text-center p-0 m-0">
                  <FontAwesomeIcon
                    role="button"
                    icon={faEye}
                    onClick={(e) =>
                      getInternalNotesModal(e, customerId, customerName, orderId)
                    }
                  />
                </div>
              );
            },
          }),
        ]
      : []),
  ];
};
